import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";

//avoid '"TypeError: reactPlugin.trackMetric is not a function"' by initialising reactPlugin prior to initialise function
const reactPlugin: ReactPlugin = new ReactPlugin();
let appInsights: ApplicationInsights;

/**
 * Create the App Insights Telemetry Service
 * @return {{reactPlugin: ReactPlugin, appInsights: Object, initialize: Function}} - Object
 */
const createTelemetryService = (): {
    reactPlugin: ReactPlugin;
    appInsights: object;
    initialize: Function;
} => {
    /**
     * Initialize the Application Insights class
     * @param {string} instrumentationKey - Application Insights Instrumentation Key
     * @param {Object} browserHistory - client's browser history, supplied by the withRouter HOC
     * @return {void}
     */
    const initialize = (instrumentationKey: string, browserHistory: Object): void => {
        if (!browserHistory) {
            throw new Error("Could not initialize Telemetry Service");
        }
        if (!instrumentationKey) {
            throw new Error("Instrumentation key not provided in ./src/telemetry-provider.jsx");
        }

        appInsights = new ApplicationInsights({
            config: {
                instrumentationKey: instrumentationKey,
                maxBatchInterval: 0,
                disableFetchTracking: false,
                extensions: [reactPlugin as any],
                extensionConfig: {
                    [reactPlugin.identifier]: {
                        history: browserHistory,
                    },
                },
            },
        });

        appInsights.loadAppInsights();
    };

    return { reactPlugin, appInsights, initialize };
};

export const ai = createTelemetryService();
export const getAppInsights = () => appInsights;
